// extracted by mini-css-extract-plugin
module.exports = {"basePage":"BasePage_basePage__2h4zf","content":"BasePage_content__KHCGk","footer":"BasePage_footer__14-0U"};